import { Component } from '@angular/core';

import { Candidato } from '@app/models/sisrh.model';
import { AutenticacaoService } from '@app/services/autenticacao.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  candidatoLogado: Candidato;

  constructor(
    private autenticacaoService: AutenticacaoService,
    private router: Router) {

    this.autenticacaoService.usuarioAtualCandidato.subscribe(x => {
      this.candidatoLogado = x;
    });

  }

  abrirCurriculo() {

    localStorage.removeItem('idInscricao');
    this.router.navigate(['/candidato/curriculo']);

  }

  sair() {

    localStorage.removeItem('idInscricao');
    this.autenticacaoService.logout();
    this.router.navigate(['/login']);

  }

  public mostrarDiv = true;
  fecharDiv(){
    this.mostrarDiv = false;
  }

}
